export default __webpack_public_path__ + "static/media/financial_year.c984c52b.svg";